import { render } from "./supplier-list.vue?vue&type=template&id=bab1d97e&scoped=true&ts=true"
import script from "./supplier-list.vue?vue&type=script&lang=ts"
export * from "./supplier-list.vue?vue&type=script&lang=ts"

import "./supplier-list.vue?vue&type=style&index=0&id=bab1d97e&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bab1d97e"]])

export default __exports__